// Item ID to name mapping for League of Legends items
// Data from Data Dragon API
export const ITEM_NAMES = {
  1001: "Boots",
  1004: "Faerie Charm",
  1006: "Rejuvenation Bead",
  1011: "Giant's Belt",
  1018: "Cloak of Agility",
  1026: "Blasting Wand",
  1027: "Sapphire Crystal",
  1028: "Ruby Crystal",
  1029: "Cloth Armor",
  1031: "Chain Vest",
  1033: "Null-Magic Mantle",
  1036: "Long Sword",
  1037: "Pickaxe",
  1038: "B. F. Sword",
  1042: "Dagger",
  1043: "Recurve Bow",
  1052: "Amplifying Tome",
  1053: "Vampiric Scepter",
  1054: "Doran's Shield",
  1055: "Doran's Blade",
  1056: "Doran's Ring",
  1057: "Negatron Cloak",
  1058: "Needlessly Large Rod",
  1082: "Dark Seal",
  1083: "Cull",
  2003: "Health Potion",
  2031: "Refillable Potion",
  2033: "Corrupting Potion",
  2055: "Control Ward",
  2138: "Elixir of Iron",
  2139: "Elixir of Sorcery",
  2140: "Elixir of Wrath",
  3001: "Evenshroud",
  3003: "Archangel's Staff",
  3004: "Manamune",
  3006: "Berserker's Greaves",
  3009: "Boots of Swiftness",
  3011: "Chemtech Putrifier",
  3020: "Sorcerer's Shoes",
  3024: "Glacial Buckler",
  3026: "Guardian Angel",
  3031: "Infinity Edge",
  3033: "Mortal Reminder",
  3035: "Last Whisper",
  3036: "Lord Dominik's Regards",
  3040: "Seraph's Embrace",
  3041: "Mejai's Soulstealer",
  3042: "Muramana",
  3044: "Phage",
  3046: "Phantom Dancer",
  3047: "Plated Steelcaps",
  3050: "Zeke's Convergence",
  3053: "Sterak's Gage",
  3057: "Sheen",
  3065: "Spirit Visage",
  3066: "Winged Moonplate",
  3067: "Kindlegem",
  3068: "Sunfire Aegis",
  3070: "Tear of the Goddess",
  3071: "Black Cleaver",
  3072: "Bloodthirster",
  3074: "Ravenous Hydra",
  3075: "Thornmail",
  3076: "Bramble Vest",
  3077: "Tiamat",
  3078: "Trinity Force",
  3082: "Warden's Mail",
  3083: "Warmog's Armor",
  3084: "Heartsteel",
  3085: "Runaan's Hurricane",
  3086: "Zeal",
  3087: "Statikk Shiv",
  3089: "Rabadon's Deathcap",
  3091: "Wit's End",
  3094: "Rapid Firecannon",
  3095: "Stormrazor",
  3100: "Lich Bane",
  3102: "Banshee's Veil",
  3107: "Redemption",
  3108: "Fiendish Codex",
  3109: "Knight's Vow",
  3110: "Frozen Heart",
  3111: "Mercury's Treads",
  3112: "Guardian's Orb",
  3113: "Aether Wisp",
  3114: "Forbidden Idol",
  3115: "Nashor's Tooth",
  3116: "Rylai's Crystal Scepter",
  3117: "Mobility Boots",
  3118: "Malignance",
  3119: "Winter's Approach",
  3121: "Fimbulwinter",
  3123: "Executioner's Calling",
  3124: "Guinsoo's Rageblade",
  3133: "Caulfield's Warhammer",
  3134: "Serrated Dirk",
  3135: "Void Staff",
  3139: "Mercurial Scimitar",
  3140: "Quicksilver Sash",
  3142: "Youmuu's Ghostblade",
  3143: "Randuin's Omen",
  3145: "Hextech Alternator",
  3152: "Hextech Rocketbelt",
  3153: "Blade of The Ruined King",
  3155: "Hexdrinker",
  3156: "Maw of Malmortius",
  3157: "Zhonya's Hourglass",
  3158: "Ionian Boots of Lucidity",
  3161: "Spear of Shojin",
  3165: "Morellonomicon",
  3172: "Zephyr",
  3177: "Guardian's Blade",
  3179: "Umbral Glaive",
  3181: "Hullbreaker",
  3184: "Guardian's Hammer",
  3190: "Locket of the Iron Solari",
  3193: "Gargoyle Stoneplate",
  3211: "Spectre's Cowl",
  3222: "Mikael's Blessing",
  3302: "Terminus",
  3330: "Scarecrow Effigy",
  3340: "Stealth Ward",
  3363: "Farsight Alteration",
  3364: "Oracle Lens",
  3400: "Your Cut",
  3504: "Ardent Censer",
  3508: "Essence Reaver",
  3513: "Eye of the Herald",
  3599: "Kalista's Black Spear",
  3600: "Kalista's Black Spear",
  3742: "Dead Man's Plate",
  3748: "Titanic Hydra",
  3801: "Crystalline Bracer",
  3802: "Lost Chapter",
  3803: "Catalyst of Aeons",
  3814: "Edge of Night",
  3850: "Spellthief's Edge",
  3851: "Frostfang",
  3853: "Shard of True Ice",
  3854: "Steel Shoulderguards",
  3855: "Runesteel Spaulders",
  3857: "Pauldrons of Whiterock",
  3858: "Relic Shield",
  3859: "Targon's Buckler",
  3860: "Bulwark of the Mountain",
  3862: "Spectral Sickle",
  3863: "Harrowing Crescent",
  3864: "Black Mist Scythe",
  3865: "World Atlas",
  3866: "Runic Compass",
  3867: "Bounty of Worlds",
  3869: "Celestial Opposition",
  3870: "Dream Maker",
  3871: "Zaz'Zak's Realmspike",
  3876: "Solstice Sleigh",
  3877: "Bloodsong",
  3901: "Fire at Will",
  3902: "Death's Daughter",
  3903: "Raise Morale",
  4003: "Lifeline",
  4004: "Spectral Cutlass",
  4005: "Imperial Mandate",
  4010: "Bloodletter's Curse",
  4011: "Sword of Blossoming Dawn",
  4012: "Sin Eater",
  4013: "Lightning Braid",
  4014: "Frozen Mallet",
  4015: "Perplexity",
  4016: "Wordless Promise",
  4017: "Hellfire Hatchet",
  4401: "Force of Nature",
  4402: "Innervating Locket",
  4403: "The Golden Spatula",
  4628: "Horizon Focus",
  4629: "Cosmic Drive",
  4630: "Blighting Jewel",
  4632: "Verdant Barrier",
  4633: "Riftmaker",
  4636: "Night Harvester",
  4637: "Demonic Embrace",
  4638: "Watchful Wardstone",
  4641: "Stirring Wardstone",
  4642: "Bandleglass Mirror",
  4643: "Vigilant Wardstone",
  4644: "Crown of the Shattered Queen",
  4645: "Shadowflame",
  6029: "Ironspike Whip",
  6035: "Silvermere Dawn",
  6333: "Death's Dance",
  6609: "Chempunk Chainsword",
  6610: "Sundered Sky",
  6616: "Staff of Flowing Water",
  6617: "Moonstone Renewer",
  6620: "Echoes of Helia",
  6621: "Dawncore",
  6630: "Goredrinker",
  6631: "Stridebreaker",
  6632: "Divine Sunderer",
  6653: "Liandry's Torment",
  6655: "Luden's Companion",
  6656: "Everfrost",
  6657: "Rod of Ages",
  6662: "Iceborn Gauntlet",
  6664: "Turbo Chemtank",
  6665: "Jak'Sho, The Protean",
  6667: "Radiant Virtue",
  6671: "Galeforce",
  6672: "Kraken Slayer",
  6673: "Immortal Shieldbow",
  6675: "Navori Flickerblade",
  6676: "The Collector",
  6677: "Rageknife",
  6690: "Rectrix",
  6691: "Duskblade of Draktharr",
  6692: "Eclipse",
  6693: "Prowler's Claw",
  6694: "Serylda's Grudge",
  6695: "Serpent's Fang",
  6696: "Axiom Arc",
  6697: "Hubris",
  6698: "Profane Hydra",
  6699: "Voltaic Cyclosword",
  7000: "Sandshrike's Claw",
  7001: "Syzygy",
  7002: "Draktharr's Shadowcarver",
  7005: "Frozen Fist",
  7006: "Typhoon",
  7009: "Icathia's Curse",
  7010: "Vespertide",
  7011: "Upgraded Aeropack",
  7012: "Liandry's Lament",
  7013: "Eye of Luden",
  7014: "Eternal Winter",
  7015: "Ceaseless Hunger",
  7016: "Dreamshatter",
  7017: "Deicide",
  7018: "Infinity Force",
  7019: "Reliquary of the Golden Dawn",
  7020: "Shurelya's Requiem",
  7021: "Starcaster",
  7022: "Seat of Command",
  7023: "Equinox",
  7024: "Caesura",
  7025: "Leviathan",
  7026: "The Unspoken Parasite",
  7027: "Primordial Dawn",
  7028: "Infinite Convergence",
  7029: "Youmuu's Wake",
  7030: "Seething Sorrow",
  7031: "Edge of Finality",
  7032: "Flicker",
  7033: "Cry of the Shrieking City",
  7050: "Gangplank Placeholder",
  8001: "Anathema's Chains",
  8020: "Abyssal Mask"
};

export const getItemName = (itemId) => {
  if (!itemId) return 'Unknown Item';
  return ITEM_NAMES[itemId] || `Item ${itemId}`;
};

export default getItemName;
